function validator(fn, errorMessage) {
    return function (value, props) {
        var getErrorMessage = function () {
            return typeof errorMessage === 'string'
                ? errorMessage
                : errorMessage(value, props);
        };
        return !fn(value, props) ? getErrorMessage() : undefined;
    };
}
export default validator;
//# sourceMappingURL=validator.js.map